import styled from '@emotion/styled';
import theme from '../../themes/default';

export const StyledSeparator = styled('hr')`
  height: 1px;
  width: 100%;
  margin: 0;
  border: none;
  flex-shrink: 0;
  background-color: ${theme.color.gray};
`;
